import { CORE_FEATURES, MODULE_CONFIG, MODULE_KEYS_ORDERED } from '../../../config/subscriptionConfig';
import { Btn } from '../../ui';

export const ComparePlansTable = () => {
    return (
        <div className="compare-plans">
            <h3 className="compare-plans-title">Compare Plans</h3>
            <p className="compare-plans-subtitle">
                Two tiers: Free Demo (30 days, everything included) and Core Program with optional add-ons.
            </p>

            <div className="compare-plans-table-wrapper">
                <table className="compare-plans-table">
                    <thead>
                        <tr>
                            <th className="compare-plans-feature-col">PLAN FEATURES</th>
                            <th className="compare-plans-plan-col">
                                <div className="compare-plans-plan-header">
                                    <span className="compare-plans-plan-name">Free Demo</span>
                                    <span className="compare-plans-plan-price">$0</span>
                                    <span className="compare-plans-plan-desc">30 days only</span>
                                    <span className="compare-plans-plan-tagline">
                                        Try everything for free. All modules unlocked, no card required.
                                    </span>
                                    <span className="compare-plans-current-badge">Current Plan</span>
                                </div>
                            </th>
                            <th className="compare-plans-plan-col compare-plans-plan-col--recommended">
                                <div className="compare-plans-plan-header">
                                    <span className="compare-plans-recommended-badge">★ RECOMMENDED</span>
                                    <span className="compare-plans-plan-name">Core Program</span>
                                    <span className="compare-plans-plan-price">$99<span className="compare-plans-plan-price-period">/mo</span></span>
                                    <span className="compare-plans-plan-desc">+ add-ons as needed</span>
                                    <span className="compare-plans-plan-tagline">
                                        Everything you need to run inspections, equipment, daily briefings, and reporting.
                                    </span>
                                    <Btn
                                        variant="primary"
                                        buttonSize="sm"
                                        buttonText="Subscribe to Core Program"
                                        buttonOnClick={() => {/* TODO: open checkout modal */ }}
                                    />
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* Core features */}
                        {CORE_FEATURES.map((feature) => (
                            <tr key={feature}>
                                <td>{feature}</td>
                                <td className="compare-plans-check">✓</td>
                                <td className="compare-plans-check">✓</td>
                            </tr>
                        ))}

                        {/* Add-on modules */}
                        {MODULE_KEYS_ORDERED.map((key) => {
                            const config = MODULE_CONFIG[key];
                            return (
                                <tr key={key}>
                                    <td>
                                        {config.name}
                                        {key === 'training' && <span className="compare-plans-feature-note"> (full training plans & compliance)</span>}
                                    </td>
                                    <td className="compare-plans-check">✓</td>
                                    <td className="compare-plans-addon-price">+ {config.rateLabel} add-on</td>
                                </tr>
                            );
                        })}

                        {/* Duration & Card rows */}
                        <tr>
                            <td>Duration</td>
                            <td className="compare-plans-value">30 days</td>
                            <td className="compare-plans-value">Ongoing monthly</td>
                        </tr>
                        <tr>
                            <td>Card required</td>
                            <td className="compare-plans-value">—</td>
                            <td className="compare-plans-check">✓</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};
